export * from './htmlpurify.js';
console.warn('`purify.js` has been moved to `htmlpurify.js`');
